import { useAuthContext } from '@/context/AuthContext.tsx';
import { usePathname } from '@/hooks/usePathname.ts';
import { adminNavData, goerNavData, ownerNavData } from '@/layouts/Default/config-nav.tsx';
import { PropsWithClassName } from '@/types/PropsWithClassName';
import { cn } from '@/utils/classNames.ts';
import { IconLogout } from '@tabler/icons-react';
import { FC } from 'react';
import { Button, Menu } from 'react-daisyui';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

type NavbarProps = {
  onClick?: () => void;
  menuClassName?: string;
};

const Navbar: FC<PropsWithClassName<NavbarProps>> = ({ className, onClick, menuClassName }) => {
  const { logout, user } = useAuthContext();
  const { t } = useTranslation();
  const pathname = usePathname();
  const navData =
    user?.role === 'admin'
      ? adminNavData
      : user?.role === 'owner'
        ? ownerNavData
        : goerNavData;
  return (
    <nav className={cn('flex flex-col gap-4 justify-between grow', className)}>
      <div className="flex flex-col grow gap-6">
        <Menu className={cn('p-0 overflow-auto flex-nowrap grow h-1 gap-2', menuClassName)}>
          {navData.map((item) => {
            const isActivated = item.path === pathname;
            const isAdmin = user?.role === 'admin';
            return (
              <Menu.Item key={item.path}>
                <Link
                  to={item.path}
                  title={t(item.title)}
                  onClick={() => (onClick ? onClick() : null)}
                  className={cn(
                    'active:bg-white text-white active:white hover:bg-white hover:bg-opacity-80 hover:text-primary flex gap-2 text-lg',
                    {
                      'bg-white bg-opacity-80 font-bold text-primary': isActivated && !isAdmin,
                      'text-primary font-bold bg-tertiary': isActivated && isAdmin,
                      'text-primary': !isActivated && isAdmin,
                    }
                  )}
                >
                  {item.icon ? <div className="w-5 h-5">{item.icon}</div> : null}
                  <span className="text-ellipsis line-clamp-1">{t(item.title)}</span>
                </Link>
              </Menu.Item>
            );
          })}
        </Menu>
      </div>
      <div className="flex flex-col">
        <Button
          onClick={logout}
          color="ghost"
          className={`!gap-4 text-lg ${user?.role === 'admin' ? 'text-primary' : 'text-white'}`}
          startIcon={<IconLogout className="w-5" />}
        >
          {t('button.logout')}
        </Button>
      </div>
    </nav>
  );
};

export default Navbar;
